import s from "../clinic.module.css";
import aa from "../AdminPortal/adminApp.module.css";
import { DatePicker, Field, TimePicker } from "../../ui";
import { addMinutesToTime, timeToMinutes } from "./calendarUtils";
import {
  SCHEDULE_DURATION_PRESETS,
  formatDurationPresetLabel,
} from "../AdminOnboarding/scheduleStepUtils";
import TimePresetChips from "./TimePresetChips";

export default function SessionDateTimeFields({
  date,
  startTime,
  endTime,
  onChange,
  durationPresets = SCHEDULE_DURATION_PRESETS,
  className = "",
  sheet = false,
}) {
  const patch = (next) => onChange({ date, startTime, endTime, ...next });

  const onStart = (nextStart) => {
    let nextEnd = endTime;
    if (timeToMinutes(nextEnd) <= timeToMinutes(nextStart)) {
      nextEnd = addMinutesToTime(nextStart, 60);
    }
    patch({ startTime: nextStart, endTime: nextEnd });
  };

  const onEnd = (nextEnd) => {
    patch({ endTime: nextEnd });
  };

  const applyDuration = (minutes) => {
    patch({ endTime: addMinutesToTime(startTime, minutes) });
  };

  const activeDuration = durationPresets.find(
    (m) => addMinutesToTime(startTime, m) === endTime,
  );

  const wrapClass = [
    s.calSessionSchedule,
    sheet ? aa.calSlotScheduleFields : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const durationChip = (minutes) =>
    sheet
      ? `${aa.calSlotDurationChip} ${
          activeDuration === minutes ? aa.calSlotDurationChipOn : ""
        }`
      : `${s.calDurationChip} ${
          activeDuration === minutes ? s.calDurationChipActive : ""
        }`;

  const durationRowClass = sheet ? aa.calSlotDurationRow : s.calDurationRow;
  const durationLabelClass = sheet ? aa.calSlotDurationLabel : s.calDurationLabel;
  const editRowClass = sheet ? aa.calSlotEditRow : s.calEditRow;
  const pickerClass = sheet ? aa.calSlotDateInput : undefined;
  const timeClass = sheet ? aa.calSlotTimeInput : undefined;

  return (
    <div className={wrapClass}>
      <Field label="Дата">
        <DatePicker
          value={date}
          onChange={(nextDate) => patch({ date: nextDate })}
          className={pickerClass}
          required
        />
      </Field>
      <div className={editRowClass}>
        <Field label="Начало">
          <TimePicker
            value={startTime}
            onChange={onStart}
            className={timeClass}
            step={sheet ? 300 : 60}
            required
          />
        </Field>
        <Field label="Окончание">
          <TimePicker
            value={endTime}
            onChange={onEnd}
            className={timeClass}
            step={sheet ? 300 : 60}
            required
          />
        </Field>
      </div>
      {sheet ? (
        <TimePresetChips
          value={startTime}
          onChange={onStart}
          label="Начало в"
        />
      ) : null}
      {durationPresets.length > 0 ? (
        <div className={durationRowClass}>
          <span className={durationLabelClass}>Длительность</span>
          {durationPresets.map((minutes) => (
            <button
              key={minutes}
              type="button"
              className={durationChip(minutes)}
              onClick={() => applyDuration(minutes)}
            >
              {formatDurationPresetLabel(minutes)}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
